import MaskedInput from 'react-text-mask'
import styled from 'styled-components'
import { CheckStyle } from '../../../../styles/components/check'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  margin-top: 90px;
  padding: 32px 35px 122px;
  
  border-top: 1px solid #E7E8FC88;
`

export const Title = styled.h2`
font-family: ${theme.font.workSans};
font-weight: ${theme.font.normal};
font-size: ${theme.font.sizes.normal};
line-height: ${theme.font.sizes.medium};
color: ${theme.colors.blue};
`

export const FormWrapper = styled.div`
  width: 100%;
  padding: 13px 0px 0px;

  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;

  & > div.form {
    flex: 1;
    max-width: 350px;
  }
`

export const NewDoubtButton = styled.button`
  width: 373px;
  height: 255px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border: 2px dashed ${theme.colors.blueLight};
  background: ${theme.colors.mainBg};
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  border-radius: ${theme.border.smallRadius};

  & > span {
    margin-top: 30px;

    font-size: ${theme.font.sizes.large};
    font-weight: ${theme.font.normal};
    line-height: ${theme.font.sizes.xlarge};
    color: ${theme.colors.brown};
  }
`

export const DoubtFormWrapper = styled.div`
  width: 373px;
  height: 255px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  overflow: hidden;

  background: #F5F5F5;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  border-radius: ${theme.border.smallRadius};
`

export const ButtonWrapper = styled.div`
  padding: 7px 16px;

  background: #E0E0E0;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 13px;
`

export const Button = styled.button`
  width: 100%;
  height: 54px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.mainBg};
  border: none;
  background: ${theme.colors.green};
  border-radius: ${theme.border.smallRadius};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  transition: filter 300ms;

  &:hover {
    filter: brightness(0.9);
  }

  & > svg {
    margin-right: 10px;
  }
`

export const DeleteButton = styled.button`
  width: 40px;
  height: 40px;

  border-radius: 40px;
  background: ${theme.colors.white};
  border: 1px solid #FFCECE;
  
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg > path {
    fill: ${theme.colors.red};
  }
`

export const SubmitButton = styled.button`
  width: 187px;
  height: 55px;
  margin: 46px 0px 0px 20px;

  background: ${theme.colors.blue};
  box-shadow: 0px 3px 2px rgba(121, 108, 95, 0.22);
  border-radius: ${theme.border.smallRadius};
  font-size: ${theme.font.sizes.large};
  font-weight: ${theme.font.semiBold};
  line-height: ${theme.font.sizes.xlarge};
  color: ${theme.colors.mainBg};
`

export const FieldGroup = styled.div`
  width: 100%;
  margin-bottom: 24px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const InputRadio = styled.input`
  ${CheckStyle}
`

export const InputMask = styled(MaskedInput)`
  width: 100%;
  height: 48px;
  padding: 13px;

  border-radius: ${theme.border.smallRadius};
  border: 1px solid #B9C1CB;
  box-shadow: 0px 3px 2px rgba(185, 193, 203, 0.22);
  background: ${theme.colors.white};
  font-size: ${theme.font.sizes.small};
  line-height: ${theme.font.sizes.normal};
  font-family: ${theme.font.montserrat};
  color: ${theme.colors.brown};

  &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #C4C4C4;
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #C4C4C4;
  }

  &::-ms-input-placeholder { /* Microsoft Edge */
    color: #C4C4C4;
  }
`

export const Preview = styled.div`
  width: 466px;
  padding: 35px 38px;
  float: right;

  background: ${theme.colors.mainBg};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.mediumRadius};

  display: flex;
  flex-direction: column;

  & > h2 {
    font-family: ${theme.font.workSans};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xlarge};
    line-height: ${theme.font.sizes.xxlarge};
    color: ${theme.colors.lightBrown};
  }

  & > img {
    margin: 15px auto;
    width: 100%;
  }
`
